import { OnInit } from '@angular/core';
import { AuthService } from 'app/security/auth.service';
import { NotificationService } from 'app/services/notification-service';
import { PolicyService } from 'app/services/policy-service';
import { ToastrService } from 'ngx-toastr';
import { CommonsText } from 'app/commons/CommonsText';
import { CommonsUtils } from 'app/commons/CommonsUtils';
import { ClientService } from 'app/services/client-service';
var HeaderNavigationBarComponent = /** @class */ (function () {
    function HeaderNavigationBarComponent(authService, notificationService, policyService, clientService, toastr) {
        this.authService = authService;
        this.notificationService = notificationService;
        this.policyService = policyService;
        this.clientService = clientService;
        this.toastr = toastr;
        this.burgerState = false;
        this.showChangeEntity = false;
        this.showDirectAreas = true;
        // La cabecera se muestra siempre en su estado "scrolleado" (barra blanca), sin depender
        // del scroll: nav-white, la barra de entidad, el aux-box y el burger azul quedan fijos.
        this.scrolled = true;
        /** Respaldo mientras no han llegado los datos de cliente: el nombre del token. */
        this.tokenFullName = '';
        this.client = null;
        this.userMenuOpen = false;
        this.toggle = true;
        this.loadingNotifications = false;
        this.loadingPolicyNotifications = false;
        this.loadingEventNotifications = false;
        // "Mis beneficios" solo para tomadores de PP09/PP11/DJ13/DJ29 (ver PolicyService).
        this.showBenefits = false;
        // "Mis asegurados" solo aplica a pólizas de Asistencia Jurídica Familiar (DJ29).
        this.hasLegalAssistanceProduct = false;
    }
    Object.defineProperty(HeaderNavigationBarComponent.prototype, "userFullName", {
        /**
         * Se compone de los datos de cliente y no del token: asi incluye el primer apellido y se
         * refresca solo al editar el perfil, porque this.client es el mismo objeto que ClientService
         * actualiza al guardar.
         */
        get: function () {
            return CommonsUtils.fullName(this.client) || this.tokenFullName;
        },
        enumerable: true,
        configurable: true
    });
    HeaderNavigationBarComponent.prototype.toggleUserMenu = function (event) {
        event.stopPropagation();
        // En movil ambos menus conviven en la barra, asi que se cierra el otro: de lo contrario
        // el panel de navegacion quedaria abierto por debajo del desplegable de usuario.
        this.burgerState = false;
        this.userMenuOpen = !this.userMenuOpen;
    };
    HeaderNavigationBarComponent.prototype.closeUserMenu = function () {
        this.userMenuOpen = false;
    };
    HeaderNavigationBarComponent.prototype.onDocumentClick = function () {
        this.userMenuOpen = false;
    };
    HeaderNavigationBarComponent.prototype.toggleBurger = function () {
        // El menu de usuario ya lo cierra el @HostListener de document:click, que se dispara al
        // propagarse este mismo clic; se deja explicito para no depender de ese efecto lateral.
        this.userMenuOpen = false;
        this.burgerState = !this.burgerState;
    };
    HeaderNavigationBarComponent.prototype.getBurgerClass = function () {
        var result = '';
        if (this.burgerState) {
            result += 'open ';
        }
        // Blanco solo cuando se recorta contra el fondo de la barra transparente. Con el menu
        // abierto va en azul: el aspa se dibuja sobre la barra blanca y antes se pintaba blanca
        // porque el panel tenia una cabecera oscura debajo, que ya no existe.
        if (!this.scrolled && !this.burgerState) {
            result += ' burger-white';
        }
        else {
            result += ' burger-blue';
        }
        return result;
    };
    HeaderNavigationBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        if ((this.authService.isLogged()) && (this.authService.getUser().entities.length > 1)) {
            this.showChangeEntity = true;
        }
        this.authService.getSelectedEntity() === 'ONLYGAL' ? this.showDirectAreas = true : this.showDirectAreas = false;
        var u = this.authService.getUser();
        if (u) {
            this.tokenFullName = ((u.name || '') + " " + (u.lastName || '')).trim();
        }
        // getClient() cachea en ClientService, asi que esto no supone una llamada extra si otra
        // pantalla ya la ha hecho. Si falla se sigue mostrando el nombre del token, sin avisar:
        // la cabecera no es el sitio para un error de carga de perfil.
        if (this.authService.isLogged()) {
            this.clientService.getClient()
                .then(function (client) { _this.client = client; })
                .catch(function () { _this.client = null; });
        }
        // Obtener notificaciones dado la configuración obtenida.
        this.loadingNotifications = true;
        this.notificationService.getNotifications()
            .then(function (success) {
            _this.loadingNotifications = false;
            _this.notifications = success.response;
        }).catch(function (error) {
            _this.loadingNotifications = false;
            _this.notifications = [];
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTI_RECI, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
        if (this.showDirectAreas) {
            this.policyService.hasBenefitProducts()
                .then(function (has) { _this.showBenefits = has; });
        }
        this.loadLegalAssistanceProduct();
    };
    HeaderNavigationBarComponent.prototype.loadLegalAssistanceProduct = function () {
        var _this = this;
        this.policyService.hasLegalAssistanceProduct()
            .then(function (has) { _this.hasLegalAssistanceProduct = has; });
    };
    HeaderNavigationBarComponent.prototype.checkPendingNotifications = function () {
        var _this = this;
        this.pendingNotifications = false;
        if (this.notifications) {
            this.notifications.forEach(function (not) {
                if (not.isRead != 'S') {
                    _this.pendingNotifications = true;
                }
            });
        }
        return this.pendingNotifications;
    };
    HeaderNavigationBarComponent.prototype.delete = function (notification) {
        var _this = this;
        var arrayIds = [notification.agenNotId];
        this.notificationService.markNotificationAsRead(arrayIds)
            .then(function (success) {
            var index = null;
            var found = _this.notifications.find(function (n) { return n.agenNotId === notification.agenNotId; });
            if (found) {
                index = _this.notifications.indexOf(found);
                if (index > -1) {
                    _this.notifications.splice(index, 1);
                }
                if (_this.notifications.length == 0) {
                    _this.pendingNotifications = false;
                }
            }
        }).catch(function (error) {
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTIFICACIONES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    HeaderNavigationBarComponent.prototype.markAsRead = function (notification) {
        var _this = this;
        if (notification && notification.isRead != 'S') {
            var found = this.notifications.find(function (n) { return n.agenNotId === notification.agenNotId; });
            if (found) {
                var index = this.notifications.indexOf(found);
                found.isRead = 'S';
                this.notifications[index] = found;
                this.checkPendingNotifications();
            }
            var arrayIds = [notification.agenNotId];
            this.notificationService.markNotificationAsRead(arrayIds)
                .then(function (success) {
            }).catch(function (error) {
                var found = _this.notifications.find(function (n) { return n.agenNotId === notification.agenNotId; });
                if (found) {
                    var index = _this.notifications.indexOf(found);
                    found.isRead = '';
                    _this.notifications[index] = found;
                    _this.checkPendingNotifications();
                }
                _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTIFICACIONES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                    timeOut: 5000
                });
            });
        }
    };
    HeaderNavigationBarComponent.prototype.readAll = function () {
        var _this = this;
        this.readingNotifications = true;
        var arrayIds = [];
        this.notifications.forEach(function (n) {
            arrayIds.push(n.agenNotId);
        });
        this.notificationService.markNotificationAsRead(arrayIds)
            .then(function (success) {
            _this.readingNotifications = false;
            _this.notifications.forEach(function (n) {
                n.isRead = 'S';
            });
            _this.pendingNotifications = false;
        }).catch(function (error) {
            _this.readingNotifications = false;
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTIFICACIONES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    HeaderNavigationBarComponent.prototype.deleteAll = function () {
        var _this = this;
        this.readingNotifications = true;
        var arrayIds = [];
        this.notifications.forEach(function (n) {
            arrayIds.push(n.agenNotId);
        });
        this.notificationService.markNotificationAsRead(arrayIds)
            .then(function (success) {
            _this.notifications = [];
            _this.pendingNotifications = false;
            _this.readingNotifications = false;
        }).catch(function (error) {
            _this.readingNotifications = false;
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_NOTIFICACIONES, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    HeaderNavigationBarComponent.prototype.getEntityClassNav = function () {
        switch (localStorage.getItem('entity')) {
            case 'C0494':
                return 'bar-meridiano';
            case 'L0639':
                return 'bar-euroins';
            case 'L1454':
                return 'bar-prima';
            case 'C0616':
                return 'bar-seguro-rga';
            case 'C0012':
                return 'bar-eterna-aseguradora';
            case 'C0037':
                return 'bar-santander';
            case 'C0072':
                return 'bar-generali';
            case 'C0124':
                return 'bar-segurcaixa';
            case 'C0133':
                return 'bar-ocaso';
            case 'C0139':
                return 'bar-patria-hispana';
            case 'C0157':
                return 'bar-helvetia';
            case 'C0161':
                return 'bar-dkv';
            case 'C0572':
                return 'bar-lagun-aro';
            case 'C0786':
                return 'bar-mutua';
            case 'DLA03':
                return 'bar-aegon';
            case 'DLA04':
                return 'bar-ergo';
            case 'DLA06':
                return 'bar-amic';
            case 'DLA07':
                return 'bar-allianz';
            case 'DLA09':
                return 'bar-vidacaixa';
            case 'E0217':
                return 'bar-erv';
            case 'L0614':
                return 'bar-nationale-suisse';
            case 'L0639':
                return 'bar-euroins';
            case 'M0084':
                return 'bar-mmt';
            case 'M0199':
                return 'bar-mutua-propietarios';
            default:
                return '';
        }
    };
    HeaderNavigationBarComponent.prototype.getEntityClass = function () {
        switch (localStorage.getItem('entity')) {
            case 'C0494':
                return 'meridiano';
            case 'L0639':
                return 'euroins';
            case 'L1454':
                return 'prima';
            case 'C0616':
                return 'seguro-rga';
            case 'C0012':
                return 'eterna-aseguradora';
            case 'C0037':
                return 'santander';
            case 'C0072':
                return 'generali';
            case 'C0124':
                return 'segurcaixa';
            case 'C0133':
                return 'ocaso';
            case 'C0139':
                return 'patria-hispana';
            case 'C0157':
                return 'helvetia';
            case 'C0161':
                return 'dkv';
            case 'C0572':
                return 'lagun-aro';
            case 'C0786':
                return 'mutua';
            case 'DLA03':
                return 'aegon';
            case 'DLA04':
                return 'ergo';
            case 'DLA06':
                return 'amic';
            case 'DLA07':
                return 'allianz';
            case 'DLA09':
                return 'vidacaixa';
            case 'E0217':
                return 'erv';
            case 'L0614':
                return 'nationale-suisse';
            case 'L0639':
                return 'euroins';
            case 'M0084':
                return 'mmt';
            case 'M0199':
                return 'mutua-propietarios';
            default:
                return '';
        }
    };
    return HeaderNavigationBarComponent;
}());
export { HeaderNavigationBarComponent };
